<template>
  <div ref="visibilityRef" :class="['SnapSlide', { 'is-mobile': isMobile }]" v-bind="$attrs">
    <div class="layout">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { isMobile } from '@/core/helpers/ui.helper';
import { useViewportIntersect } from '@/views/composables/hooks/useViewportIntersect';

interface SnapSlideProps {
  onBeforeEnter?: (target: HTMLElement) => void;
  onIsEntering?: (target: HTMLElement) => void;
  onHasEntered?: (target: HTMLElement) => void;
  onBeforeLeave?: (target: HTMLElement) => void;
  onIsLeaving?: (target: HTMLElement) => void;
  onHasLeft?: (target: HTMLElement) => void;
}

const props = defineProps<SnapSlideProps>();

const { target: visibilityRef } = useViewportIntersect({
  onBeforeEnter: props.onBeforeEnter,
  onIsEntering: props.onIsEntering,
  onHasEntered: props.onHasEntered,
  onBeforeLeave: props.onBeforeLeave,
  onIsLeaving: props.onIsLeaving,
  onHasLeft: props.onHasLeft,
});
</script>

<style lang="scss" scoped>
.SnapSlide {
  scroll-snap-align: center;
  scroll-snap-stop: always;
  flex: none;
}

.layout {
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
